module.exports = __webpack_public_path__ + "static/hero_01-d4cd481770c70879fc08d0bdeac78191.jpg";